import React from 'react';
import { VerticalForm, FormInput } from '../../components/';
import { Modal, Button, Spinner } from 'react-bootstrap';
import moment from 'moment';

const EditMasterModal = ({
    t,
    title,
    showModal,
    closeModalWithHeaderClass,
    onSubmit,
    schemaResolver,
    extraField,
    showEditModalData = {},
    stationName = [],
    vendor = [],
    loader,
    varient,
}) => {
    return (
        <Modal show={showModal} size="xs" onHide={closeModalWithHeaderClass}>
            <Modal.Header closeButton className="modal-colored-header">
                <h4 className="modal-title text-black">{t(title)}</h4>
            </Modal.Header>

            <Modal.Body>
                <VerticalForm onSubmit={onSubmit} resolver={schemaResolver}>
                    {/* Extra Field from Parent */}
                    {extraField && (
                        <FormInput
                            label={t(extraField.label)}
                            type={extraField.type}
                            name={extraField.name}
                            placeholder={t(extraField.placeholder)}
                            containerClass="mb-3"
                            defaultValue={extraField.value}
                            onInput={extraField.onInput}
                        />
                    )}

                    <FormInput
                        label={t('Asset Type Code')}
                        type="text"
                        name="assetTypeCode"
                        placeholder={t('Enter asset type code')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.asset_type_code || ''}
                    />

                    <FormInput
                        label={t('Asset Type ID')}
                        type="text"
                        name="assetTypeId"
                        placeholder={t('Enter asset type id')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.asset_type_id || ''}
                    />

                    <FormInput
                        label={t('SMMS Asset Code')}
                        type="text"
                        name="smmsAssetCode"
                        placeholder={t('Enter smms asset code')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.smms_asset_code || ''}
                    />

                    <FormInput
                        label={t('SMMS Asset Name')}
                        type="text"
                        name="smmsAssetName"
                        placeholder={t('Enter smms asset name')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.smms_asset_name || ''}
                    />

                    <FormInput
                        label={t('Asset Number Code')}
                        type="text"
                        name="assetNumberCode"
                        placeholder={t('Enter asset number code')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.asset_number_code || ''}
                    />

                    <FormInput
                        label={t('Asset Number ID')}
                        type="text"
                        name="assetNumberId"
                        placeholder={t('Enter asset number id')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.asset_number_id || ''}
                    />

                    <FormInput
                        label={t('Parameter Type ID')}
                        type="text"
                        name="parameterTypeId"
                        placeholder={t('Enter parameter type id')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.parameter_type_id || ''}
                    />

                    <FormInput
                        label={t('Device ID')}
                        type="text"
                        name="deviceId"
                        placeholder={t('Enter device id')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.device_id || ''}
                        // disabled
                    />

                    <FormInput
                        label={t('Channel Number')}
                        type="text"
                        name="channel"
                        placeholder={t('Enter channel number')}
                        containerClass="mb-3"
                        defaultValue={showEditModalData.channel || ''}
                        onInput={(e) => (e.target.value = e.target.value.replace(/[^0-9]/g, ''))}
                    />

                    {/* Type Select */}
                    <FormInput type="select" label={t('Type')} name="type" containerClass="mb-3" key="typeSelect">
                        <option value={showEditModalData.type || ''}>
                            {showEditModalData.type
                                ? showEditModalData.type.charAt(0).toUpperCase() + showEditModalData.type.slice(1)
                                : t('Select Type')}
                        </option>
                        {['current', 'voltage'].map((item) =>
                            item !== showEditModalData.type?.toLowerCase() ? (
                                <option key={item} value={item}>
                                    {item.charAt(0).toUpperCase() + item.slice(1)}
                                </option>
                            ) : null
                        )}
                    </FormInput>

                    {/* Vendor Select */}
                    <FormInput type="select" label={t('Vendor Name')} name="vendorId" containerClass="mb-3">
                        <option value={showEditModalData.vendor_id || ''}>
                            {showEditModalData?.vendorDetails?.vendor_cloud_name || t('Select Vendor')}
                        </option>
                        {vendor
                            .filter((item) => item.id !== showEditModalData.vendor_id)
                            .map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.vendor_cloud_name}
                                </option>
                            ))}
                    </FormInput>

                    {/* Station Select */}
                    <FormInput type="select" label={t('Station Name')} name="stationId" containerClass="mb-3">
                        <option value={showEditModalData.station_id || ''}>
                            {showEditModalData?.stationDetails?.name || t('Select Station')}
                        </option>
                        {stationName
                            .filter((item) => item.id !== showEditModalData.station_id)
                            .map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item.name}
                                </option>
                            ))}
                    </FormInput>

                    {/* Created Date */}
                    <FormInput
                        label={t('Created Date')}
                        type="text"
                        containerClass="mb-3"
                        defaultValue={moment(showEditModalData?.updatedAt).format('Do MMM YYYY, h:mm A') || ''}
                        disabled
                    />

                    {/* Footer */}
                    <Modal.Footer className="d-flex justify-content-end">
                        <Button
                            type="submit"
                            className="btn btn-submit"
                            style={{
                                backgroundColor: '#F9B74C',
                                fontFamily: 'Poppins, sans-serif',
                                width: '200px',
                                borderRadius: '0%',
                                border: 'none',
                            }}
                            disabled={loader}>
                            {loader ? (
                                <>
                                    <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
                                    {t(' Loading')}
                                </>
                            ) : (
                                <>
                                    <i className="mdi mdi-login"></i>
                                    {t('Submit')}
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </VerticalForm>
            </Modal.Body>
        </Modal>
    );
};

export default EditMasterModal;
